// Polyfill URL.parse for browsers older than Chrome 126 / Safari 18.
// pdfjs-dist >=4.4 uses it unconditionally.
export {};

if (typeof (URL as any).parse !== "function") {
  (URL as any).parse = function (url: string, base?: string) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}
